import { jsx as o, jsxs as C } from "react/jsx-runtime";
import { Row as $, Col as x } from "antd";
import "dayjs";
import { t as d, T as n } from "./period-BbmcGyLd.js";
import { useMemo as L, memo as E, useState as F } from "react";
import { u as c } from "./styled-components.browser.esm-BFmoFexH.js";
import { d as G } from "./index-a388f2ac-Cf1pu7LW.js";
import { FlexMetricOptionRow as D, IconContainer as b, ContentCol as P, DeleteContainer as T } from "@biron-data/react-components";
import { F as q } from "./XCircleIcon-C46OdWM6.js";
import { MetricOptionsFormKeys as R } from "./selector/metrics/options/MetricOptionForm.types.js";
import { D as I, E as W } from "./utils-wNl4DVdv.js";
import { useLanguageResolver as j } from "@biron-data/react-contexts";
const z = (r) => {
  const t = d(r.start).startOf("day");
  return d(r.end).endOf("day").diff(t, "day") + 1;
}, nr = (r) => L(() => z(r), [r]), H = (r, t, e, i) => {
  const s = Q(r);
  return {
    start: d(e.start).subtract(t ?? i, s).startOf("day"),
    end: d(e.end).subtract(t ?? i, s).endOf("day")
  };
}, N = ({ start: r, end: t }, e = "dd DD MMM YYYY") => `${r.format(e)} - ${t.format(e)}`, Q = (r) => {
  switch (r) {
    case n.DAY:
      return "day";
    case n.WEEK:
      return "week";
    case n.MONTH:
      return "month";
    case n.QUARTER:
      return "quarter";
    case n.YEAR:
      return "year";
    default:
      return r;
  }
}, sr = E(({
  value: r,
  setActiveKey: t,
  onDelete: e,
  timeInterval: i,
  dayDifference: s,
  iconSize: Y,
  iconSpan: k
}) => {
  var p, m, w, f, g, u, M;
  const a = j(), [y, h] = F(!1), O = I((p = r == null ? void 0 : r.growth) == null ? void 0 : p.period), l = W(t);
  return /* @__PURE__ */ o(B, { children: ((m = r == null ? void 0 : r.growth) == null ? void 0 : m.period) && ((w = r.growth) == null ? void 0 : w.type) && /* @__PURE__ */ o(J, { children: /* @__PURE__ */ o(U, { children: /* @__PURE__ */ C($, { children: [
    /* @__PURE__ */ o(x, { span: k, onClick: () => t == null ? void 0 : t(R.growth), children: /* @__PURE__ */ o(D, { $clickable: l, children: /* @__PURE__ */ o(b, { size: Y, children: /* @__PURE__ */ o(G.Growth, {}) }) }) }),
    /* @__PURE__ */ o(P, { span: 19, onClick: () => t == null ? void 0 : t(R.growth), children: /* @__PURE__ */ C(
      D,
      {
        $clickable: l,
        onMouseOver: () => h(!0),
        onMouseLeave: () => h(!1),
        children: [
          /* @__PURE__ */ o("span", { children: `${a.get(`growth.type-preset.${(f = r == null ? void 0 : r.growth) == null ? void 0 : f.type.toLowerCase()}`)} ${a.get(`growth.value.${O}`, (g = r.growth) == null ? void 0 : g.period.quantity)}` }),
          i && /* @__PURE__ */ o(S, { children: N(
            H(
              (u = r.growth) == null ? void 0 : u.period.unit,
              ((M = r.growth) == null ? void 0 : M.period.quantity) ?? void 0,
              i,
              s
            ),
            "DD MMM YYYY"
          ) }),
          y && e && /* @__PURE__ */ o(T, { children: /* @__PURE__ */ o(b, { clickable: !0, size: 14, color: "var(--light-grey)", children: /* @__PURE__ */ o(q, { onClick: () => e(["growthLabel", "growthType", "growthPeriod", "growthInvert"]) }) }) })
        ]
      }
    ) })
  ] }) }) }) });
}), S = c.span`
  font-style: italic;
  font-weight: 400;
  line-height: 18px;

  color: #C6C6C6;
`, U = c.div`
  display: flex;
  flex-direction: column;
`, B = c.div`
  width: 100%;
  cursor: pointer;
`, J = c.div`
  align-items: center;
  gap: 10px;
`;
export {
  nr as D,
  sr as M,
  H as m,
  N as w
};
//# sourceMappingURL=MetricGrowthResume-ClJnPTa-.js.map
